import React, { Dispatch, SetStateAction } from 'react';
import { useGeneralHooks } from '../../../../../../../Hooks/hooks';
import useCreateMenuHooks from './createMenu-hooks';
import Loading from '../../../../../../../Components/Loading/loading';
import { ICategory, IMenuItemResponce, MenuListResponce } from '../../../../../../../Interfaces/responseTypes';
import SimpleCategoryCard from '../../CategoryCard/simple';
import { ButtonTypes, ICategoryAction, ICategoryItem, IMenuItemActions, MenuListContentTypes, MenuListTypes, SimpleCategoryItemTypes } from '../../../../../../../Interfaces/componentTypes';
import MenuList from '../MenuList/menuList';
import Button from '../../../../../../../Components/Button/button';
import { AccordeonArrow } from '../../../../../../../Assets/Icons';
import styles from './createMenu.module.scss';

interface IProps {
  menu?: MenuListResponce;
  menuLoading?: boolean;
  companyId: number;
  categories?: ICategory[];
  categoryLoading: boolean;
  categoryOrderList: number[];
  itemOrderList: number[] | [];
  menuItemOrderLoading: boolean,
  isItemOrderListChange: boolean;
  itemActions: IMenuItemActions[];
  orderListUodateLoading?: boolean;
  contentType: MenuListContentTypes,
  categoryActions: ICategoryAction[];
  categoryItems: ICategoryItem | null;
  isCategoryOrderListChanged: boolean;
  onBack: () => void;
  onUpdateCategoryOrderList: () => void;
  onUpdateMenuItemOrderList: () => void;
  onOpenCreateTemplateDialog: () => void;
  onMenuItemOrderChange: (updatedOrder: number[]) => void
  onCategoryOrderChange?: (updatedOrder: number[]) => void;
  setContentType: Dispatch<SetStateAction<MenuListContentTypes>>,
  onOpenDeleteCategoryDialog: (id: number, title: string) => void,
  onOpenAddMenuItemDialog: (companyId: number, categoryId: number, title: string) => void;
  handleItemIsActive: (categoryId: number, data: IMenuItemResponce) => void
};

const CreateMenu: React.FC<IProps> = (props) => {
  const {
    menu,
    menuLoading,
    companyId,
    categories,
    itemActions,
    contentType,
    itemOrderList,
    categoryItems,
    categoryActions,
    categoryLoading,
    categoryOrderList,
    menuItemOrderLoading,
    isItemOrderListChange,
    orderListUodateLoading,
    isCategoryOrderListChanged,
    setContentType,
    handleItemIsActive,
    onMenuItemOrderChange,
    onCategoryOrderChange,
    onOpenAddMenuItemDialog,
    onUpdateMenuItemOrderList,
    onUpdateCategoryOrderList,
    onOpenCreateTemplateDialog,
    onOpenDeleteCategoryDialog,
  } = props;
  const safeMenu = menu ?? [];
  const safeCategories = categories ?? [];
  const { showCategories, onShowCategories, categoryHeight, categoryItemsRef } = useCreateMenuHooks(
    safeCategories,
    safeMenu.length,
  );
  const { t, activeLanguage } = useGeneralHooks();

  if (menuLoading) {
    return (
      <div className={styles.container}>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {
        categoryLoading
          ?
          <Loading />
          :
          <div className={styles.categoryContainer}>
            <div className={styles.categoryHeader}>
              <div className={styles.cotegoriesBox} ref={categoryItemsRef}>
                <div className={styles.accordeonTitle} onClick={onShowCategories}>
                  <p>{t('My_Business.Select_Category')}</p>
                  <img
                    src={AccordeonArrow}
                    alt="icon.svg"
                    className={`${styles.icon} ${showCategories ? styles.iconRotated : ''}`}
                  />
                </div>
                {showCategories
                  &&
                  <div className={styles.categoryItems} style={!showCategories ? { display: "none" } : undefined}>
                    {safeCategories.map((item) => {
                      const localizedName = item[`name_${activeLanguage}` as keyof ICategory] || item.name_en;
                      return (
                        <SimpleCategoryCard
                          key={item.id}
                          id={item.id}
                          title={localizedName as string}
                          onClick={() => onOpenAddMenuItemDialog(companyId, item.id, localizedName as string)}
                          onDelete={onOpenDeleteCategoryDialog}
                          isAutor={item.is_author}
                        />
                      )
                    })}
                    <SimpleCategoryCard
                      title={t('Buttons.Create_New')}
                      onClick={onOpenCreateTemplateDialog}
                      type={SimpleCategoryItemTypes.BUTTON}
                    />
                  </div>}
              </div>
            </div>
          </div>
      }
      <div className={styles.menuBox} style={{ marginTop: categoryHeight }}>
        <div 
        className={!safeMenu.length ? styles.noData : styles.menuBody}
        >
          <MenuList
            menu={safeMenu}
            menuLoading={false}
            companyId={companyId}
            contentType={contentType}
            itemActions={itemActions}
            type={MenuListTypes.EDIT}
            itemOrderList={itemOrderList}
            categoryItems={categoryItems!}
            categoryActions={categoryActions}
            categoryOrderList={categoryOrderList}
            setContentType={setContentType}
            handleItemIsActive={handleItemIsActive}
            onMenuItemOrderChange={onMenuItemOrderChange}
            onCategoryOrderChange={onCategoryOrderChange}
            onOpenAddMenuItemDialog={onOpenAddMenuItemDialog}
          />
        </div>

      </div>
      {
        isCategoryOrderListChanged && contentType === MenuListContentTypes.CATEGORIES
          ?
          < Button
            title={t('Buttons.Save')}
            buttonType={ButtonTypes.Primery}
            buttonStyle={styles.updateOrderListBtn}
            onClick={onUpdateCategoryOrderList}
            isLoading={orderListUodateLoading}
          />
          :
          isItemOrderListChange && contentType === MenuListContentTypes.ITEMS
          &&
          < Button
            title={t('Buttons.Save')}
            buttonType={ButtonTypes.Primery}
            buttonStyle={styles.updateOrderListBtn}
            onClick={onUpdateMenuItemOrderList}
            isLoading={menuItemOrderLoading}
          />
      }
    </div >

  )
}

export default CreateMenu
